import {
  MOUNT,
  UNMOUNT,
  FETCH_REPORT,
  FETCH_REPORT_START,
  FETCH_REPORT_SUCCESS,
  FETCH_REPORT_ERROR,
  UPDATE_REPORT,
  REMOVE_REPORT,
  CLEAR_REPORTS,
  ON_SELECT_FILTER,
  ON_UNSELECT_FILTER,
  CLEAR_FILTER,
  UPDATE_QUERY,
  UPDATE_QUERY_CHANGES,
  UPDATE_QUERY_SOURCE,
  RESET_QUERY,
  UPDATE_PROJECT_COUNTS_QUERY,
  UPDATE_PROJECT_SPECIFICATION_QUERY,
  ADD_SPECIFICATION_CHART,
  REMOVE_SPECIFICATION_CHART,
  UPDATE_AE_RESOURCES_QUERY,
  UPDATE_AE_REGIONS_QUERY,
  TOGGLE_DASHBOARD_QUERY,
  ProductHierarchyEnum,
  PartnerSiteEnum,
  AeRegionEnum,
  chartsEnum
} from './constants'
import {
  buildAsyncAction,
} from 'containers/Async/actions'
import {
  createNamedAction
} from 'helpers/ActionUtil'
import {
  projectSpecificationQuerySelector
} from './selectors'

// Mount/Unmount
const mount = () => ({ type: MOUNT })
const unmount = () => ({ type: UNMOUNT })

// Report actions
const fetchReport = (report, query) => ({ type: FETCH_REPORT, report, query })
const fetchReportStart = () => ({ type: FETCH_REPORT_START })
const fetchReportSuccess = () => ({ type: FETCH_REPORT_SUCCESS })
const fetchReportError = (error) => ({ type: FETCH_REPORT_ERROR, error })
const startFetchReport = buildAsyncAction(
  FETCH_REPORT,
  FETCH_REPORT_START,
  [FETCH_REPORT_SUCCESS, FETCH_REPORT_ERROR]
)
const updateReport = (report) => ({ type: UPDATE_REPORT, report })
const removeReport = (report, attr) => ({ type: REMOVE_REPORT, report, attr })
const clearReports = () => ({ type: CLEAR_REPORTS })

// Filter actions
const onSelectFilter = (report) => ({ type: ON_SELECT_FILTER, report })
const onUnselectFilter = (report) => ({ type: ON_UNSELECT_FILTER, report })
const clearFilter = () => ({ type: CLEAR_FILTER })

// Query actions
const updateQuery = (() => {
  const updateQueryAction = (query) => {
    return {
      type: UPDATE_QUERY,
      query
    }
  }
  const combinedQueries = { ...PartnerSiteEnum, ...ProductHierarchyEnum, ...AeRegionEnum }
  const actions = Object.keys(combinedQueries)
    .reduce((result, key) => {
      const name = combinedQueries[key].label
      return {
        ...result,
        [name]: createNamedAction(name, updateQueryAction)
      }
    }, {})
  const getAction = (type) => {
    return actions[type.label]
  }
  return (type, value) => {
    const action = getAction(type)
    return dispatch => dispatch(action(value))
  }
})()


const updateQueryChanges = (() => {
  const updateQueryChangesAction = (changes) => {
    return {
      type: UPDATE_QUERY_CHANGES,
      changes
    }
  }
  const combinedQueries = { ...PartnerSiteEnum, ...ProductHierarchyEnum, ...AeRegionEnum }
  const actions = Object.keys(combinedQueries)
    .reduce((result, key) => {
      const name = combinedQueries[key].label
      return {
        ...result,
        [name]: createNamedAction(name, updateQueryChangesAction)
      }
    }, {})
  const getAction = (type) => {
    return actions[type.label]
  }
  return (type, value) => {
    const action = getAction(type)
    return dispatch => dispatch(action(value))
  }
})()


const updateQuerySource = (() => {
  const updateQuerySourceAction = (source) => {
    return {
      type: UPDATE_QUERY_SOURCE,
      source
    }
  }
  const combinedQueries = { ...PartnerSiteEnum, ...ProductHierarchyEnum, ...AeRegionEnum }
  const actions = Object.keys(combinedQueries)
    .reduce((result, key) => {
      const name = combinedQueries[key].label
      return {
        ...result,
        [name]: createNamedAction(name, updateQuerySourceAction)
      }
    }, {})
  const getAction = (type) => {
    return actions[type.label]
  }
  return (type, value) => {
    const action = getAction(type)
    return dispatch => dispatch(action(value))
  }
})()

const resetQuery = () => ({ type: RESET_QUERY })

const applyQuery = (queries, reports) => {
  return dispatch => {
    const promises = queries.map(query => dispatch(updateQuery(query, query.changes)))
    Promise.all(promises)
      .then(() => {
        reports.map(report => dispatch(fetchReport(report.type, report.type == chartsEnum.SPECIFICATION.value ? { value: report.value, parent: report.parent } : null)))
      })
  }
}

function resetQueryAction(reports) {
  return dispatch =>
    Promise.resolve(dispatch(resetQuery()))
      .then(() => {
        reports.map(report => dispatch(fetchReport(report.type, report.type == chartsEnum.SPECIFICATION.value ? { value: report.value, parent: report.parent } : null)))
      })
}

// individial charts query actions
const updateProjectCountsQuery = (query) => ({ type: UPDATE_PROJECT_COUNTS_QUERY, query })

function updateProjectCountsQueryAction(lifecycles) {
  return dispatch =>
    Promise.resolve(dispatch(updateProjectCountsQuery(lifecycles)))
      .then(() => {
        dispatch(fetchReport(chartsEnum.TOTAL_COUNTS.value))
      })
}



const updateProjectSpecifictionQuery = (attr, index) => ({ type: UPDATE_PROJECT_SPECIFICATION_QUERY, attr, index })

function updateProjectSpecificationQueryAction(attr, index) {
  return (dispatch, getState) => {
    const selection = projectSpecificationQuerySelector(getState())
    const isPresent = selection.some(attribute => attr.parent == attribute.parent && attr.value == attribute.value)
    if (!isPresent) {
      Promise.resolve(dispatch(fetchReport(chartsEnum.SPECIFICATION.value, attr)))
        .then(() => {
          Promise.resolve(dispatch(updateProjectSpecifictionQuery(attr, index)))
        })
    } else {
      Promise.resolve(dispatch(updateProjectSpecifictionQuery(attr, index)))
    }
  }
}

const addSpecificationChart = () => ({ type: ADD_SPECIFICATION_CHART })

const removeSpecificationChart = (index) => ({ type: REMOVE_SPECIFICATION_CHART, index })



const updateAeResourcesQuery = (query) => ({ type: UPDATE_AE_RESOURCES_QUERY, query })

function updateAeResourcesQueryAction(segments) {
  return dispatch =>
    Promise.resolve(dispatch(updateAeResourcesQuery(segments)))
      .then(() => {
        dispatch(fetchReport(chartsEnum.AE_RESOURCES.value))
      })
}



const updateAeRegionsQuery = (query) => ({ type: UPDATE_AE_REGIONS_QUERY, query })

function updateAeRegionsQueryAction(regions) {
  return dispatch =>
    Promise.resolve(dispatch(updateAeRegionsQuery(regions)))
      .then(() => {
        dispatch(fetchReport(chartsEnum.AE_REGIONS.value))
      })
}

const toggleDashboardQuery = () => ({ type: TOGGLE_DASHBOARD_QUERY })

export {
  mount,
  unmount,
  fetchReport,
  fetchReportStart,
  fetchReportSuccess,
  fetchReportError,
  updateReport,
  removeReport,
  startFetchReport,
  clearReports,
  onSelectFilter,
  onUnselectFilter,
  clearFilter,
  updateQuery,
  updateQueryChanges,
  updateQuerySource,
  resetQuery,
  applyQuery,
  resetQueryAction,
  updateProjectCountsQuery,
  updateProjectCountsQueryAction,
  updateProjectSpecifictionQuery,
  updateProjectSpecificationQueryAction,
  addSpecificationChart,
  removeSpecificationChart,
  updateAeResourcesQuery,
  updateAeResourcesQueryAction,
  updateAeRegionsQuery,
  updateAeRegionsQueryAction,
  toggleDashboardQuery
}